import {publish} from '../../utils/pubsub';
import {render} from './interscroller';

export function loadCustomCreative(data) {
	if (data.action === 'showInterscroller') {
		render(data.options);
	} else {
		publish(data.action, data.options);
	}
}
